// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__16hez","dragIcon":"Choice_dragIcon__1KfOh","left":"Choice_left__2U6V9","input":"Choice_input__39A-o"};